//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const MassUpgradeFeatureFlags: FeatureFlag = {"Id":"MassUpgradeFeatureFlags","Label":"Mass Upgrade Feature Flags","Impact":"Can toggle all mass-upgrades feature flags at once","Mode":3,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":5};
